var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExamsmanagementicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1680,
    height: 1050,
    transform: "translate(-142 -89)",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 432,
    height: 1050,
    transform: "translate(-142 -89)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -42,
    y: -89,
    width: 332,
    height: 1050,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -42,
    y: -89,
    width: 332,
    height: 1050,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40901 2.40901C2.83097 1.98705 3.40326 1.75 4 1.75H16C16.5967 1.75 17.169 1.98705 17.591 2.40901C18.0129 2.83097 18.25 3.40326 18.25 4V5.25H1.75V4C1.75 3.40326 1.98705 2.83097 2.40901 2.40901ZM0.25 6V4C0.25 3.00544 0.645088 2.05161 1.34835 1.34835C2.05161 0.645088 3.00544 0.25 4 0.25H16C16.9946 0.25 17.9484 0.645088 18.6517 1.34835C19.3549 2.05161 19.75 3.00544 19.75 4V6V12.673C19.75 13.0872 19.4142 13.423 19 13.423C18.5858 13.423 18.25 13.0872 18.25 12.673V6.75H1.75V16C1.75 16.5967 1.98705 17.169 2.40901 17.591C2.83097 18.0129 3.40326 18.25 4 18.25H12.672C13.0862 18.25 13.422 18.5858 13.422 19C13.422 19.4142 13.0862 19.75 12.672 19.75H4C3.00544 19.75 2.05161 19.3549 1.34835 18.6517C0.645088 17.9484 0.25 16.9946 0.25 16V6Z",
    fill: "#3F7FAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 8.75C4.33579 8.75 4 9.08579 4 9.5C4 9.91421 4.33579 10.25 4.75 10.25H11C11.4142 10.25 11.75 9.91421 11.75 9.5C11.75 9.08579 11.4142 8.75 11 8.75H4.75ZM4 12.5C4 12.0858 4.33579 11.75 4.75 11.75H9C9.41421 11.75 9.75 12.0858 9.75 12.5C9.75 12.9142 9.41421 13.25 9 13.25H4.75C4.33579 13.25 4 12.9142 4 12.5ZM4 15.5C4 15.0858 4.33579 14.75 4.75 14.75H8C8.41421 14.75 8.75 15.0858 8.75 15.5C8.75 15.9142 8.41421 16.25 8 16.25H4.75C4.33579 16.25 4 15.9142 4 15.5Z",
    fill: "#3F7FAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 11.75C13.4289 11.75 11.75 13.4289 11.75 15.5C11.75 17.5711 13.4289 19.25 15.5 19.25C17.5711 19.25 19.25 17.5711 19.25 15.5C19.25 13.4289 17.5711 11.75 15.5 11.75ZM10.25 15.5C10.25 12.6005 12.6005 10.25 15.5 10.25C18.3995 10.25 20.75 12.6005 20.75 15.5C20.75 18.3995 18.3995 20.75 15.5 20.75C12.6005 20.75 10.25 18.3995 10.25 15.5Z",
    fill: "#3F7FAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4801 13C15.8943 13 16.2301 13.3358 16.2301 13.75V13.8199C16.4287 13.8939 16.6159 13.998 16.7847 14.1297L16.8344 14.1009C17.1928 13.8934 17.6517 14.0158 17.8592 14.3742C18.0667 14.7327 17.9444 15.1915 17.5859 15.3991L17.5564 15.4162C17.5753 15.5254 17.5856 15.6362 17.587 15.7476C17.5884 15.8617 17.5804 15.9755 17.5632 16.0878L17.5859 16.1009C17.9444 16.3085 18.0667 16.7673 17.8592 17.1258C17.6517 17.4842 17.1928 17.6066 16.8344 17.3991L16.8182 17.3897C16.6586 17.5196 16.4802 17.6253 16.2889 17.7032C16.2694 17.7111 16.2498 17.7188 16.2301 17.7261V17.75C16.2301 18.1642 15.8943 18.5 15.4801 18.5C15.0659 18.5 14.7301 18.1642 14.7301 17.75V17.7084C14.7102 17.7004 14.6903 17.6921 14.6705 17.6835C14.4893 17.6045 14.3207 17.5003 14.1694 17.3743L14.121 17.4019C13.761 17.6067 13.3031 17.4809 13.0983 17.1209C12.8934 16.7609 13.0192 16.303 13.3792 16.0981L13.4395 16.0638C13.4248 15.9597 13.418 15.854 13.4193 15.7476C13.4205 15.6439 13.4295 15.541 13.4459 15.4398L13.3792 15.4019C13.0192 15.197 12.8934 14.7391 13.0983 14.3791C13.3031 14.0191 13.761 13.8933 14.121 14.0981L14.2027 14.1446C14.3632 14.0164 14.5411 13.9132 14.7301 13.8377V13.75C14.7301 13.3358 15.0659 13 15.4801 13ZM15.9798 15.4356C15.958 15.4049 15.9333 15.3762 15.9059 15.3501C15.7955 15.245 15.6484 15.1872 15.496 15.1891C15.3436 15.1909 15.198 15.2523 15.0902 15.3601C14.9824 15.4679 14.921 15.6135 14.9192 15.7659C14.9173 15.9183 14.9751 16.0654 15.0802 16.1758C15.1339 16.2322 15.1984 16.2773 15.2698 16.3084C15.2993 16.3213 15.3298 16.3316 15.3609 16.3394C15.3997 16.3332 15.4396 16.33 15.4801 16.33C15.5298 16.33 15.5784 16.3349 15.6254 16.3441C15.6588 16.3369 15.6916 16.3269 15.7233 16.3139C15.7955 16.2846 15.861 16.2411 15.9161 16.186C15.9221 16.1799 15.928 16.1738 15.9338 16.1675C15.9489 16.1255 15.9679 16.0842 15.9911 16.0442C16.0123 16.0076 16.0361 15.9734 16.0622 15.9418C16.0794 15.8849 16.0878 15.8256 16.0871 15.7659C16.0861 15.688 16.0696 15.6111 16.0385 15.5397C16.0332 15.5277 16.0276 15.5158 16.0216 15.5042C16.0109 15.4885 16.0007 15.4724 15.9911 15.4558C15.9872 15.4491 15.9834 15.4424 15.9798 15.4356Z",
    fill: "#3F7FAE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1680,
    height: 1050,
    fill: "white",
    transform: "translate(-142 -89)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamsmanagementicon);
export default __webpack_public_path__ + "static/media/examsmanagementicon.cd880882fd30d7c7bf23f151f18ad6ef.svg";
export { ForwardRef as ReactComponent };